/* tslint:disable */
/* eslint-disable */
/**
 * Survey
 * 現地調査用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResponseErrorUnauthorizedAllOfError } from './ResponseErrorUnauthorizedAllOfError';
import {
    ResponseErrorUnauthorizedAllOfErrorFromJSON,
    ResponseErrorUnauthorizedAllOfErrorFromJSONTyped,
    ResponseErrorUnauthorizedAllOfErrorToJSON,
} from './ResponseErrorUnauthorizedAllOfError';

/**
 * 
 * @export
 * @interface ResponseErrorUnauthorized
 */
export interface ResponseErrorUnauthorized {
    /**
     * 
     * @type {ResponseErrorUnauthorizedAllOfError}
     * @memberof ResponseErrorUnauthorized
     */
    error: ResponseErrorUnauthorizedAllOfError;
}

/**
 * Check if a given object implements the ResponseErrorUnauthorized interface.
 */
export function instanceOfResponseErrorUnauthorized(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "error" in value;

    return isInstance;
}

export function ResponseErrorUnauthorizedFromJSON(json: any): ResponseErrorUnauthorized {
    return ResponseErrorUnauthorizedFromJSONTyped(json, false);
}

export function ResponseErrorUnauthorizedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseErrorUnauthorized {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'error': ResponseErrorUnauthorizedAllOfErrorFromJSON(json['error']),
    };
}

export function ResponseErrorUnauthorizedToJSON(value?: ResponseErrorUnauthorized | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'error': ResponseErrorUnauthorizedAllOfErrorToJSON(value.error),
    };
}

